import React, { useState } from "react";
import Layout from "../components/Layout"; // adjust path
import SettingSidebar from "../components/Setttingsidebar"; // adjust path
import CustomContainer from "../components/Customsettingscontain";

export default function SettingsPageShell({ title, headerRight, children ,  wrapperClassName = "rr-wrapper",}) {
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
   
      <div className="settings-container">

        {settingsOpen && (
          <div
            className="settings-sidebar-backdrop"
            onClick={() => setSettingsOpen(false)}
          />
        )}

        <div
          className={`settings-sidebar-wrap ${
            settingsOpen ? "settings-sidebar-open" : ""
          }`}
        >
          <SettingSidebar />
        </div>

        <CustomContainer fluid={false} className={wrapperClassName}>
         
        
          {/* <div className="rr-top-header">
            <div className="rr-header-left">
              <button
                className="rr-settings-toggle"
                onClick={() => setSettingsOpen((p) => !p)}
                title="Settings menu"
              >
                <i className="bi bi-sliders" />
              </button>
              <h3>{title}</h3>
            </div>

            {headerRight}
          </div> */}

          {title || headerRight ? (
          <div className="rr-top-header">
            <div className="rr-header-left">
              <button
                className="rr-settings-toggle"
                onClick={() => setSettingsOpen((p) => !p)}
                title="Settings menu"
              >
                <i className="bi bi-sliders" />
              </button>
              {title && <h3>{title}</h3>}
            </div>
            {headerRight}
          </div>
        ) : (
          // No title/headerRight passed — page has its own header markup,
          // so render ONLY the toggle icon, nothing else
          <button
            className="rr-settings-toggle rr-settings-toggle-standalone"
            onClick={() => setSettingsOpen((p) => !p)}
            title="Settings menu"
          >
            <i className="bi bi-sliders" />
          </button>
        )}

          {children}

        </CustomContainer>
      </div>
  );
}